export default __webpack_public_path__ + "static/media/0649fa7c4b51209f213125fe38192b8f.svg";